import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { Toaster } from "./components/ui/sonner";
import CVPage from "./pages/CVPage";
import KetchupPage from "./pages/KetchupPage";
import KtrlHomePage from "./pages/ktrl/KtrlHomePage";
import KtrlTjenesterPage from "./pages/ktrl/KtrlTjenesterPage";
import KtrlBloggPage from "./pages/ktrl/KtrlBloggPage";
import KtrlBlogPostFilosofi from "./pages/ktrl/KtrlBlogPostFilosofi";
import KtrlPrivacyPage from "./pages/ktrl/KtrlPrivacyPage";

const hostname = window.location.hostname;
const isKetchupSubdomain = hostname === 'ketchup.ktrl.no';
const isCvSubdomain = hostname === 'cv.ktrl.no';

function App() {
  if (isKetchupSubdomain) {
    return <KetchupPage />;
  }

  if (isCvSubdomain) {
    return (
      <LanguageProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<CVPage />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" />
        </div>
      </LanguageProvider>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<KtrlHomePage />} />
          <Route path="/tjenester" element={<KtrlTjenesterPage />} />
          <Route path="/blogg" element={<KtrlBloggPage />} />
          <Route path="/blogg/klaw-ktrl-filosofi" element={<KtrlBlogPostFilosofi />} />
          <Route path="/personvern" element={<KtrlPrivacyPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
